import axios from 'axios'
import { multitenantAuthApiBasePath } from './fetch'

export const getMultitenantUser = (accessToken) => {
  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  }
  return axios.get(`${multitenantAuthApiBasePath}/User`, config)
}
